import { de, enUS, es, fr, it, ja, ko, type Locale, nl, pl, pt, ru, tr, zhCN, zhTW } from 'date-fns/locale'

import type { Language } from './lib/types'

export const dateLocales: Record<Language, Locale> = {
    cn: zhCN,
    de,
    en: enUS,
    es,
    fr,
    it,
    ja,
    ko,
    pl,
    pt,
    ru,
    tr,
    nl,
    tw: zhTW,
}
